import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.grey.darken1,
        secondary: colors.blueGrey.darken4,
        tertiary: "#9B1717",
        info: '#E6E8ED',
        success: '#518ADB',
        accent: '#ec72ce',
        left: '#FF6600',
        right: '#0066FF',
      },
    },
    options: { customProperties: true },
  },
});
